var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form tab-content" },
    [
      _c("input-field", {
        attrs: {
          value: "",
          label: _vm.$t("ExistingMaterial"),
          size: "large",
          inputType: "group"
        }
      }),
      _vm._v(" "),
      _vm.isElectrical
        ? _c("input-field", {
            attrs: {
              value: _vm.getValueInObject("tp_pe_clamps"),
              label: _vm.$t("Clamps"),
              size: "small",
              inputType: "select",
              selectOptions: "list_pole_clamp",
              fieldDisabled: _vm.readOnly
            },
            on: {
              input: function($event) {
                return _vm.updateValue("tp_pe_clamps", $event)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("input-field", {
        attrs: {
          value: _vm.getValueInObject(
            "tp_pe_existing_aerial_subterranean_transitions"
          ),
          label: _vm.$t("AerialSubterraneanTransitions"),
          size: "small",
          inputType: "number",
          step: 1,
          min: 0,
          max: 4,
          fieldDisabled: _vm.readOnly
        },
        on: {
          input: function($event) {
            return _vm.updateValue(
              "tp_pe_existing_aerial_subterranean_transitions",
              $event
            )
          }
        }
      }),
      _vm._v(" "),
      _c("input-field", {
        attrs: {
          value: _vm.getValueInObject("tp_pe_existing_ground_cables"),
          label: _vm.$t("GroundCables"),
          size: "small",
          inputType: "number",
          step: 1,
          max: 2,
          fieldDisabled: _vm.readOnly
        },
        on: {
          input: function($event) {
            return _vm.updateValue("tp_pe_existing_ground_cables", $event)
          }
        }
      }),
      _vm._v(" "),
      _c("input-field", {
        attrs: {
          value: _vm.getValueInObject("tp_pe_existing_closures"),
          label: _vm.$tc("Closure", 2),
          size: "small",
          inputType: "number",
          step: 1,
          max: 3,
          fieldDisabled: _vm.readOnly
        },
        on: {
          input: function($event) {
            return _vm.updateValue("tp_pe_existing_closures", $event)
          }
        }
      }),
      _vm._v(" "),
      _c("input-field", {
        attrs: {
          value: _vm.getValueInObject("tp_pe_existing_riser_pipes"),
          label: _vm.$t("RiserPipes"),
          size: "small",
          inputType: "number",
          step: 1,
          max: 2,
          fieldDisabled: _vm.readOnly
        },
        on: {
          input: function($event) {
            return _vm.updateValue("tp_pe_existing_riser_pipes", $event)
          }
        }
      }),
      _vm._v(" "),
      _c("div", { staticStyle: { width: "100%" } }),
      _vm._v(" "),
      _vm.isElectrical
        ? _c("input-field", {
            attrs: {
              value: _vm.getValueInObject("tp_pe_existing_bt_hanging_support"),
              label: _vm.$t("BTHangingSupport"),
              size: "small",
              inputType: "number",
              step: 1,
              fieldDisabled: _vm.readOnly
            },
            on: {
              input: function($event) {
                return _vm.updateValue(
                  "tp_pe_existing_bt_hanging_support",
                  $event
                )
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isElectrical
        ? _c("input-field", {
            attrs: {
              value: _vm.getValueInObject("tp_pe_existing_bt_anchor_support"),
              label: _vm.$t("BTAnchorSupport"),
              size: "small",
              inputType: "number",
              step: 1,
              fieldDisabled: _vm.readOnly
            },
            on: {
              input: function($event) {
                return _vm.updateValue(
                  "tp_pe_existing_bt_anchor_support",
                  $event
                )
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isElectrical
        ? _c("input-field", {
            attrs: {
              value: _vm.getValueInObject(
                "tp_pe_existing_bt_double_anchor_support"
              ),
              label: _vm.$t("BTDoubleAnchorSupport"),
              size: "small",
              inputType: "number",
              step: 1,
              fieldDisabled: _vm.readOnly
            },
            on: {
              input: function($event) {
                return _vm.updateValue(
                  "tp_pe_existing_bt_double_anchor_support",
                  $event
                )
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("input-field", {
        attrs: {
          value: _vm.getValueInObject("tp_pe_existing_ft_hanging_support"),
          label: _vm.$t("FTHangingSupport"),
          size: "small",
          inputType: "number",
          step: 1,
          fieldDisabled: _vm.readOnly
        },
        on: {
          input: function($event) {
            return _vm.updateValue("tp_pe_existing_ft_hanging_support", $event)
          }
        }
      }),
      _vm._v(" "),
      _c("input-field", {
        attrs: {
          value: _vm.getValueInObject("tp_pe_existing_ft_anchor_support"),
          label: _vm.$t("FTAnchorSupport"),
          size: "small",
          inputType: "number",
          step: 1,
          fieldDisabled: _vm.readOnly
        },
        on: {
          input: function($event) {
            return _vm.updateValue("tp_pe_existing_ft_anchor_support", $event)
          }
        }
      }),
      _vm._v(" "),
      _c("input-field", {
        attrs: {
          value: _vm.getValueInObject(
            "tp_pe_existing_ft_double_anchor_support"
          ),
          label: _vm.$t("FTDoubleAnchorSupport"),
          size: "small",
          inputType: "number",
          step: 1,
          fieldDisabled: _vm.readOnly
        },
        on: {
          input: function($event) {
            return _vm.updateValue(
              "tp_pe_existing_ft_double_anchor_support",
              $event
            )
          }
        }
      }),
      _vm._v(" "),
      _c("input-field", {
        attrs: {
          value: _vm.getValueInObject("tp_pe_existing_ft_standoff"),
          label: _vm.$t("FTStandoff"),
          size: "small",
          inputType: "number",
          step: 1,
          fieldDisabled: _vm.readOnly
        },
        on: {
          input: function($event) {
            return _vm.updateValue("tp_pe_existing_ft_standoff", $event)
          }
        }
      }),
      _vm._v(" "),
      _c("input-field", {
        attrs: {
          value: "",
          label: _vm.$t("MaterialToInstall"),
          size: "large",
          inputType: "group"
        }
      }),
      _vm._v(" "),
      _c("input-field", {
        attrs: {
          value: _vm.getValueInObject("tp_pe_install_closures"),
          label: _vm.$tc("Closure", 2),
          size: "small",
          inputType: "number",
          step: 1,
          fieldDisabled: _vm.readOnly
        },
        on: {
          input: function($event) {
            return _vm.updateValue("tp_pe_install_closures", $event)
          }
        }
      }),
      _vm._v(" "),
      _c("input-field", {
        attrs: {
          value: _vm.getValueInObject("tp_pe_install_fo_standoff"),
          label: _vm.$t("FOStandoff"),
          size: "small",
          inputType: "number",
          step: 1,
          fieldDisabled: _vm.readOnly
        },
        on: {
          input: function($event) {
            return _vm.updateValue("tp_pe_install_fo_standoff", $event)
          }
        }
      }),
      _vm._v(" "),
      _c("input-field", {
        attrs: {
          value: _vm.getValueInObject("tp_pe_install_ras_fo"),
          label: "RAS FO",
          size: "small",
          inputType: "number",
          step: 1,
          fieldDisabled: _vm.readOnly
        },
        on: {
          input: function($event) {
            return _vm.updateValue("tp_pe_install_ras_fo", $event)
          }
        }
      }),
      _vm._v(" "),
      _c("input-field", {
        attrs: {
          value: _vm.getValueInObject("tp_pe_install_extensions"),
          label: _vm.$t("Extensions"),
          size: "small",
          inputType: "number",
          step: 1,
          fieldDisabled: _vm.readOnly
        },
        on: {
          input: function($event) {
            return _vm.updateValue("tp_pe_install_extensions", $event)
          }
        }
      }),
      _vm._v(" "),
      _c("input-field", {
        attrs: {
          value: _vm.getValueInObject("tp_pe_install_slack"),
          label: _vm.$t("Slack"),
          size: "small",
          inputType: "number",
          step: 1,
          fieldDisabled: _vm.readOnly
        },
        on: {
          input: function($event) {
            return _vm.updateValue("tp_pe_install_slack", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-39aef266", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39aef266","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/PoleEffortModule/MaterialTab.vue
// module id = null
// module chunks = 